module.exports = __webpack_public_path__ + "idea-management-1-84327245673c509638d2f1ca7394e1fa.webp";